import styled from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'

export const WrapperContent = styled.div<{ collapsed?: boolean }>`
  flex-grow: 1;
  width: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  margin-left: ${props => (props.collapsed ? '64px' : '248px')};
  transition: margin-left 0.2s ease-in-out;

  @media (min-width: 1150px) {
    display: flex;
  }

  @media (max-width: ${tokens.breakpoints.desktop - 1}px) {
    margin-left: 0;
  }
`
